var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpencv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 238,
    viewBox: "0 0 256 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.048 237.714C161.439 237.714 134.096 210.37 134.096 176.761C134.096 155.05 145.774 134.826 164.572 123.977L182.858 155.647C175.342 159.987 170.667 168.076 170.667 176.761C170.667 189.976 181.834 201.142 195.048 201.142C208.263 201.142 219.429 189.976 219.429 176.761C219.429 168.076 214.754 159.987 207.239 155.647L225.524 123.977C244.322 134.826 256 155.056 256 176.761C256 210.37 228.657 237.714 195.048 237.714Z",
    fill: "#4191FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.475 113.547L140.19 81.8761C147.705 77.5363 152.38 69.4418 152.38 60.7622C152.38 47.5477 141.214 36.3812 127.999 36.3812C114.785 36.3812 103.618 47.5477 103.618 60.7622C103.618 69.4479 108.293 77.5363 115.809 81.8761L97.5231 113.547C78.7253 102.691 67.0469 82.4612 67.0469 60.7561C67.0469 27.1469 94.3901 -0.196289 127.999 -0.196289C161.608 -0.196289 188.952 27.1469 188.952 60.7561C188.952 82.4673 177.273 102.697 158.475 113.547Z",
    fill: "#F52537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9529 237.884C39.8695 237.884 19.3407 226.955 8.05842 207.426C-8.74615 178.315 1.26223 140.97 30.367 124.159C49.1708 113.304 72.5278 113.304 91.3194 124.159L73.0337 155.83C65.5121 151.484 56.1742 151.484 48.6527 155.83C37.2059 162.437 33.122 177.688 39.7232 189.135C46.3304 200.575 61.5807 204.671 73.0337 198.058C80.5491 193.718 85.2241 185.624 85.2241 176.944H121.796C121.796 198.649 110.117 218.873 91.3194 229.729C81.7499 235.263 71.2782 237.884 60.9529 237.884Z",
    fill: "#6DD669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 237.714,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpencv);
export default __webpack_public_path__ + "static/media/opencv.0f128460059cd1ecc2bb285567fb9ba5.svg";
export { ForwardRef as ReactComponent };